import { ETH } from '../constants/assets'
import type { ChainConfig } from '../types'
import { getQuickNodeRpcUrl } from '../utils/getQuickNodeRpcUrl'

export const KATANA = {
  name: 'katana',
  chainId: 747474,
  averageBlockTimeSeconds: 1,
  explorerUrl: 'https://katanascan.com/',
  nativeAsset: ETH,
  slip44: 60,
  wrappedNativeAsset: '0x4200000000000000000000000000000000000006',
  blockscoutApiUrl: undefined,
  etherscanSupported: true,
  publicRpcUrls: ['https://katana.drpc.org', 'https://katana.drpc.org'],
  getPrivateRpcUrls: () => {
    const katana: string[] = []
    process.env.ROUTEME_API_KEY && katana.push(`https://lb.routeme.sh/rpc/747474/${process.env.ROUTEME_API_KEY}`)
    const quickNodeUrl = getQuickNodeRpcUrl('katana')
    quickNodeUrl && katana.push(quickNodeUrl)
    return katana
  },
} as const satisfies ChainConfig
